import React from 'react';

import { useThreeDStockContentView } from '../../../../../hooks/useThreeDStockContentView';

import { PureTooltipIconButtonHelper } from '../../../../../../../helpers/buttons/PureTooltipIconButtonHelper';

import { StockTabs } from '../../../../../stockConstants';
import { IconsEnum } from '../../../../../../../assets/icons/types';
import { words } from '../../../../../../../locales/keys';

interface ThreeDStockContentImageToggleViewButtonProps {
  tab: StockTabs;
}

function ThreeDStockContentImageToggleViewButton({
  tab
}: ThreeDStockContentImageToggleViewButtonProps) {
  const { handleToggleView, isGridView } = useThreeDStockContentView({ tab });

  return (
    <PureTooltipIconButtonHelper
      className="p-2.5 rounded-md inline-flex items-center leading-6 focus:ring-base border border-gray-300 dark:border-gray-700 shadow-sm bg-white dark:bg-gray-800 text-gray-500 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors duration-150 ease-out"
      dataGa="products-toggle-view-button"
      icon={isGridView ? IconsEnum.VIEW_LIST : IconsEnum.VIEW_GRID}
      iconClassName="h-5 w-5"
      onClick={handleToggleView}
      tooltipI18nText={isGridView ? words.listView : words.gridView}
    />
  );
}

export default ThreeDStockContentImageToggleViewButton;
